import "./CategoryTag.scss";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { buildEntityTagLink } from "utils/helper";
import { useUserContext } from "api/user/UserProvider";
import { useGeneralContext } from "api/directory/general/GeneralProvider";

const CategoryTag = ({
  deleteOption,
  label,
  many,
  onClick,
  onDelete,
  showing,
  type,
  color,
  isInputSearchPopup,
  dataTestId,
  linkValue,
  profile,
}) => {
  const { userScope } = useUserContext() || {};
  const { namesByFilters } = useGeneralContext() || {};

  const tag = (
    <div
      className={`category-tag  ${type || "standard"} ${color} ${
        many ? "many" : ""
      }`}
      onClick={(id) => (!deleteOption && onClick ? onClick(id) : null)}
    >
      <div
        className={`category-tag-title ${showing ? "showing" : ""}`}
        id={label?.toString()?.toLowerCase()?.replace(" ", "-")}
        data-testid={dataTestId}
      >
        {label}
      </div>
      {deleteOption && (
        <div
          className="category-tag-delete-container"
          onClick={(id) => onDelete(id)}
          data-testid={`${dataTestId}-delete_tag`}
        >
          <div className="category-tag-delete-container-delete"></div>
        </div>
      )}
    </div>
  );

  if (linkValue && !onClick && !deleteOption) {
    const tagLink = buildEntityTagLink({
      option: { value: linkValue, type, profile },
      userScope,
      namesByFilters,
    });
    if (tagLink) {
      return (
        <Link
          to={tagLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(ev) => ev.stopPropagation()}
          className="search-tag-link"
        >
          {tag}
        </Link>
      );
    }
  }

  return tag;
};
CategoryTag.propTypes = {
  deleteOption: PropTypes.any,
  label: PropTypes.any,
  many: PropTypes.bool,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  showing: PropTypes.bool,
  type: PropTypes.string,
  color: PropTypes.string,
  dataTestId: PropTypes.string,
  linkValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  profile: PropTypes.string,
};
CategoryTag.defaultProps = {
  deleteOption: false,
  label: null,
  many: false,
  onClick: null,
  onDelete: null,
  showing: false,
  type: "",
  color: "",
  dataTestId: "",
};

export default CategoryTag;
